import { useLayerStore } from "../state/useLayerStore";
import type { TransitView } from "../map/layers/transit";

const OPTIONS: { value: TransitView; label: string; title: string }[] = [
  { value: "stops", label: "Stops", title: "One dot per stop, sized by weekday service" },
  { value: "lines", label: "Lines", title: "Each line's track" },
];

/**
 * Choose how the transit network is drawn.
 *
 * Stops answer "can I get anywhere from this flat"; lines answer "where does
 * the network actually go" — different enough questions that drawing both at
 * once serves neither.
 */
export function TransitViewControl() {
  const view = useLayerStore((s) => s.transitView);
  const setView = useLayerStore((s) => s.setTransitView);

  return (
    <div className="ml-6.5 mt-1.5 flex rounded-lg border border-line p-0.5">
      {OPTIONS.map((o) => {
        const on = view === o.value;
        return (
          <button
            key={o.value}
            onClick={() => setView(o.value)}
            title={o.title}
            className={`flex-1 rounded-md px-1 py-0.5 text-[11px] leading-tight transition-colors ${
              on ? "bg-accent font-medium text-white" : "text-ink-soft hover:bg-surface-alt"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
